import { useCallback, useEffect, useState } from "react";
import ApiService from "../../services/apiService";
import { method } from "lodash";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import {
  Button,
  Card,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import { color } from "highcharts";
import { usePagination } from "../../hooks/usePagination";
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";
import { toast } from "react-toastify";

import { Navigate, useNavigate } from "react-router-dom";
import LoadingComponent from "../lodingComponent";

const AddChakInGroup = () => {
  const [deviceData, setDeviceData] = useState<any[]>();
  const [ChakInGroup, setChakInGroup] = useState<any[]>();
  const [selected, setSelected] = useState<
    { chakId: number; groupNameMasterId: any }[]
  >([]);
  const [selectedDelete, setSelectedDelete] = useState<
    { chakId: number; groupNameMasterId: number }[]
  >([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [groupId, setGroupId] = useState<any>();
  const [groupIdSecond, setGroupIdSecond] = useState<any>();
  const [modalOpen, setModalOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const navigate = useNavigate()

  const toggleModal = () => setModalOpen(!modalOpen);

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setSearchQuery,
    searchQuery,
    filterOn,
    setSortBy,
    loading,
  } = usePagination({
    endpoint: `group/getchaskpergroup`,

    enabled: true,
  });
  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [setPageNumber, totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, [setPageNumber, totalPages]);


  const deleteSelectedChaks = async () => {
    try {
      const response = await ApiService.axiosApi(
        `/groupinfo/delete-groupinfo`,
        {
          method: "DELETE",
          data: selectedDelete,
        }
      );
      if (response.success) {
        toast.success("Deleted Successfully");
        setDeleteModalOpen(false)
      } else {
        toast.error("Unable To Delete");
      }
    } catch (e) {
      console.log(e);
    }
  };


  const ChakAdded = async () => {
    try {
      const response = await ApiService.axiosApi(`/groupchaklink`, {
        method: "POST",
        data: selected,
      });
      if (response.success) {
          toast.success("Chak Added to the group Successfully");
          setModalOpen(false);
          setSelected([]);

      } else {
          toast.error("Unable to Add Chak In Group");
      }
    } catch (e) {
       console.log(e);
    }
  };
 

  const getChakInGroup = async (id: any) => {
    try {
      const response = await ApiService.axiosApi(
        `/groupinfo/get-by-masterid/${id}`,
        {
          method: "GET",
        }
      );
      if (response.success) {
        setChakInGroup(response.data);
      } else {
        console.log("unable to get chak in group");
      }
    } catch (e) {
      console.log(e);
    }
  };


  const getDevice = async () => {
    try {
      const response = await ApiService.axiosApi(`/chack`, {
        method: "GET",
        params: {
          pageNumber: 0,
          pageSize: 0,
        },
      });
      if (response.success) {
        setDeviceData(response.data.data);
      } else {
        console.log("unable to get device");
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDevice();
  }, []);


  const handleToggle = (chakId: number, groupNameMasterId: number) => {
    setSelected((prev) => {
      const exists = prev.some((x) => x.chakId === chakId);

      if (exists) {
        // remove it
        return prev.filter((x) => x.chakId !== chakId);
      } else {
        // add new object
        return [...prev, { chakId, groupNameMasterId: groupId }];
      }
    });
  };


  return (
    <>
      <Breadcrumbs mainTitle="Schedule Group" parent="Schedule" />
      <Card>
        <CommonCardHeader title="Schedule Group" headClass={"pb-3"} />
        <div className="table-responsive">
          <Table
            hover
            size="sm"
            className="align-middle text-center"
            style={{
              fontSize: "0.95rem",
              fontFamily: "Segoe UI, Roboto, sans-serif",
            }}
          >
            <thead className="bg-light-primary">
              <tr>
                <th
                  style={{
                    width: "40%",
                    fontWeight: 600,
                    color: "#333",
                    padding: "6px",
                    fontSize: "1rem",

                    height: "50px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Group Name
                </th>

               

                <th
                  style={{
                    width: "40%",
                    fontWeight: 600,
                    color: "#333",
                    padding: "6px",
                    fontSize: "1rem",

                    height: "50px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Total No Of Chaks
                </th>
                <th
                  style={{
                    width: "40%",
                    fontWeight: 600,
                    color: "#333",
                    padding: "6px",
                    fontSize: "1rem",

                    height: "50px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="table-body w-100">
              {data.length > 0 ? (
                data.map((group) => (
                  <tr key={group.groupId}>
                    <td>{group.groupName}</td>
                    <td>{group.totalChaks}</td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => {
                            getChakInGroup(group.groupId);
                            setViewModalOpen(true);
                             navigate(`/view-edit-chak/${group.groupId}`)
                          }}
                        >
                          View
                        </Button>

                       
                      

                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center text-muted">
                  <LoadingComponent/>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div
            className=" d-flex justify-content-end align-content-center"
            style={{ marginRight: "10px", marginTop: "10px" }}
          >
            <p style={{ marginRight: "10px", marginTop: "8px" }}>
              Page {pageNumber} of {totalPages}
            </p>
            <button
              onClick={handlePrev}
              disabled={pageNumber === 1}
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
            >
              <LeftIcon className="icon" />
            </button>
            <button
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
              onClick={handleNext}
              disabled={pageNumber === totalPages}
            >
              <RightIcon className="icon" />
            </button>
          </div>
        </div>

        {/** Select Chak to group**/}
        <Modal isOpen={modalOpen} toggle={toggleModal} centered size="lg">
          <ModalHeader toggle={toggleModal}>Select Members</ModalHeader>
          <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table
              bordered
              hover
              responsive
              className="align-middle text-center"
            >
              <thead className="table-light">
                <tr>
                  <th style={{ width: "5%" }}>
                    <Input
                      type="checkbox"
                      checked={
                        (deviceData?.length ?? 0) > 0 &&
                        selected.length === (deviceData?.length ?? 0)
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelected(deviceData?.map((item) => item.id) || []);
                        } else {
                          setSelected([]);
                        }
                      }}
                    />
                  </th>
                  <th style={{ fontSize: "15px" }}>Chak Name</th>
                  <th style={{ fontSize: "15px" }}>Chak Area</th>
                  <th style={{ fontSize: "15px" }}>Scheme/Village</th>
                  <th style={{ fontSize: "15px" }}>Distributary/Zone</th>
                  <th style={{ fontSize: "15px" }}>Device Type</th>
                </tr>
              </thead>
              <tbody>
                {(deviceData?.length ?? 0) > 0 ? (
                  deviceData?.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <Input
                          type="checkbox"
                          checked={selected.some((x) => x.chakId === item.id)}
                          onChange={() => handleToggle(item.id, groupId)}
                        />
                      </td>
                      <td>{item.chackName}</td>
                      <td>{item.chackArea}</td>
                      <td>{item.scheme_Village}</td>
                      <td>{item.distributary_Zone}</td>
                      <td>{item.deviceType}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center text-muted">
                      <LoadingComponent/>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={toggleModal}>
              Cancel
            </Button>
            <Button color="primary" onClick={ChakAdded}>
              Save
            </Button>
          </ModalFooter>
        </Modal>

        {/*modal for view*/}

        <Modal
          isOpen={viewModalOpen}
          toggle={() => setViewModalOpen(false)}
          centered
          size="lg"
        >
          <ModalHeader toggle={() => setViewModalOpen(false)}>
            Chaks in Group
          </ModalHeader>
          <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table
              bordered
              hover
              responsive
              className="align-middle text-center"
            >
              <thead className="table-light">
                <tr>
                  <th style={{ fontSize: "15px" }}>Chak Name</th>
                  <th style={{ fontSize: "15px" }}>Chak Area</th>
                  <th style={{ fontSize: "15px" }}>Scheme/Village</th>
                  <th style={{ fontSize: "15px" }}>Distributary/Zone</th>
                  <th style={{ fontSize: "15px" }}>Wua</th>
                  <th style={{ fontSize: "15px" }}>DeviceType</th>
                </tr>
              </thead>
              <tbody>
                {ChakInGroup?.map((item) => (
                  <tr key={item.id}>
                    <td>{item.chakName}</td>
                    <td>{item.chakArea}</td>
                    <td>{item.schemeVillage}</td>
                    <td>{item.distributaryZone}</td>
                    <td>{item.headQuaterName}</td>
                    <td>{item.deviceType}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => setViewModalOpen(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

       
        
       {/*Delete Modal*/}

       <Modal
  isOpen={deleteModalOpen}
  toggle={() => setDeleteModalOpen(false)}
  centered
  size="lg"
>
  <ModalHeader toggle={() => setDeleteModalOpen(false)}>
    Remove Chaks from Group
  </ModalHeader>
  <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
    <Table bordered hover responsive className="align-middle text-center">
      <thead className="table-light">
        <tr>
          <th style={{ width: "5%" }}>
          <Input
  type="checkbox"
  checked={
    (ChakInGroup?.length ?? 0) > 0 &&
    selectedDelete.length === (ChakInGroup?.length ?? 0)
  }
  onChange={(e) => {
    if (e.target.checked) {
      // Select all
      setSelectedDelete(
        (ChakInGroup ?? []).map((item) => ({
          chakId: item.id,
          groupNameMasterId: groupId,
        }))
      );
    } else {
      // Deselect all
      setSelectedDelete([]);
    }
  }}
/>

          </th>
          <th>Chak Name</th>
          <th>Chak Area</th>
          <th>Scheme/Village</th>
          <th>Distributary/Zone</th>
          <th>Wua</th>
          <th >DeviceType</th>
        </tr>
      </thead>
      <tbody>
        {ChakInGroup?.map((item) => (
          <tr key={item.id}>
            <td>
              <Input
                type="checkbox"
                checked={selectedDelete.some((x) => x.chakId === item.chakId)}
                onChange={() => {
                  setSelectedDelete((prev) => {
                    const exists = prev.some((x) => x.chakId === item.chakId);
                    if (exists) {
                      // Remove this row from selected
                      return prev.filter((x) => x.chakId !== item.chakId);
                    } else {
                      // Add this row to selected
                      return [
                        ...prev,
                        { chakId: item.chakId, groupNameMasterId: groupId },
                      ];
                    }
                  });
                }}
              />
            </td>
            <td>{item.chakName}</td>
            <td>{item.chakArea}</td>
            <td>{item.schemeVillage}</td>
            <td>{item.distributaryZone}</td>
            <td>{item.headQuaterName}</td>
            <td>{item.deviceType}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </ModalBody>
  <ModalFooter>
    <Button color="danger" onClick={() => setDeleteModalOpen(false)}>
      Cancel
    </Button>
    <Button color="primary" onClick={deleteSelectedChaks}>
      Delete Selected
    </Button>
  </ModalFooter>
</Modal>



      </Card>
    </>
  );
};

export default AddChakInGroup;
